import React, {Component} from 'react';
import Table from '../../../../components/Table';
import PersonFormModal from './components/PersonFormModal';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import DeletePersonModal from './components/DeletePersonModal';
import PersonDetailModal from './components/PersonDetailModal';
import avatar from "../../../../images/face-0.jpg";
import './styles.css';
import _ from "lodash";
import moment from 'moment';
import {MembersList as sGroups} from '../../utils/PeopleSGroups';


class People extends Component {

    static contextTypes = {api: PropTypes.object};

    constructor(props) {
        super(props);
        console.log(props.history.location.pathname);


        this.state = {
            detailingPerson: false,
            onlyIhs: props.history.location.pathname === '/ihs-members',
        };

        this.loadData = _.debounce(this.loadData, 450);
    }



    loadData = (tableState) => {
        this.tableState = tableState;
        console.log(this.state.onlyIhs);

        let filters=    {
            ...tableState.filters, 'membership[exists]': true,
            sGroups

        }

        if (this.state.onlyIhs) {
            filters = {
                ...filters, 'membership.ihsMemberNumber[exists]': true
            }
        }
        
        console.log(filters);
        

        this.context.api.people.get(tableState.page, tableState.pageSize, '@Class.People.people.get',filters)
    };

    addPerson = (person, photo, registrationFile, academicResumeFile) => {

        this.setState({addingLoading: true});
        this.context.api.people.create(person, '@Class.People.people.create', photo, registrationFile, academicResumeFile)
            .then(() => {
                this.loadData(this.tableState);
                this.setState({addingPerson: false, addingLoading: false});
            })
            .catch(() => {
                this.setState({addingLoading: false});
            });
    };

    editPerson = (person, photo, registrationFile, academicResumeFile) => {

        this.setState({editingLoading: true});
        this.context.api.people.edit(person.id, person, '@Class.People.people.edit', photo, registrationFile, academicResumeFile)
            .then(() => {
                this.loadData(this.tableState);
                this.setState({editingPerson: false, editingLoading: false});
            })
            .catch(() => {
                this.setState({editingLoading: false});
            });
    };

    deletePerson = (person) => {

        this.setState({deletingPerson: false});
        this.context.api.people.delete(person.id, '@Class.People.people.delete');
    };


    tableDefinition =() => {
        let definition = [
            {
                name: 'Miembro activo',
                id: 'membership.hasDebts',
                accessor: (person) => {
                    const photo =
                        (person.photo)
                            ? this.context.api.appFiles.getUrl(person.photo.id)
                            : avatar;

                    const annuityPayments =
                        (person && person.membership && person.membership.annuityPayments)
                            ? person.membership.annuityPayments
                            : [];

                    const checkMembershipTypePayment = (typeName) => {
                        const currentYear = moment().year();
                        return annuityPayments.some(({
                                                         year = 0,
                                                         type = ""
                                                     }) => (typeName === type) && (year === currentYear));
                    };

                    const isRegisteredToLastYearIHS = () => {
                        const currentYear = moment().year();
                        const unwantedIhsYears =
                            (person && person.membership && person.membership.unwantedIHSYears)
                                ? person.membership.unwantedIHSYears
                                : [];

                        let flag = true;
                        unwantedIhsYears.forEach((unwantedYear) => {
                            if (parseInt(unwantedYear.year, 10) === parseInt(currentYear, 10)) {
                                flag = false;
                            }
                        });
                        return flag;
                    }

                    const hasMembership = checkMembershipTypePayment('membership');
                    const paidIHS = checkMembershipTypePayment('ihs');
                    const isRegisteredToCurrentIhsYear = isRegisteredToLastYearIHS();
                    let ihsIconClass = '';
                    if (isRegisteredToCurrentIhsYear && paidIHS) {
                        ihsIconClass = 'hasIHS';
                    } else if (isRegisteredToCurrentIhsYear && !paidIHS) {
                        ihsIconClass = 'notPaidIHS';
                    }

                    const isDeath = !!person.dateOfDeath;

                    return (
                        <div
                            style={{backgroundImage: `url(${photo})`}}
                            className='list-photo'
                        >
                            {!isDeath ?
                                <div>
                                    <span className={`paid-icon ${(hasMembership) ? 'paid' : ''}`}/>
                                    <span className={`paid-icon ${ihsIconClass}`}/>
                                </div> :
                                <span className={`paid-icon ${(isDeath) ? 'isDeath' : ''}`}/>
                            }
                        </div>
                    )
                },
                filterable: true,
                filterComponent: (props) => {
                    const onChange = (e) => props.onChange(e.target.value);
                    return <select value={props.value} onChange={onChange}>
                        <option value=''>Todos</option>
                        <option value='false'>Activo</option>
                        <option value='true'>Inactivo</option>
                    </select>;
                },
            },
            {
                name: 'No. Miembro AMCEMIG',
                id: 'membership.id',
                filterable: true,
                accessor: (person) => person.membership !== null && person.membership.id
            },
            {
                name: 'No. Miembro IHS',
                id: 'membership.ihsMemberNumber',
                filterable: true,
                accessor: (person) => person.membership !== null && person.membership.ihsMemberNumber
            },
            {
                name: 'Título',
                id: 'title',
                filterable: true,
                accessor: 'title',
                filterComponent: (props) => {
                    const onChange = (e) => props.onChange(e.target.value);
                    return <select value={props.value} onChange={onChange}>
                        <option value=''>Todos</option>
                        <option value='DR.'>DR.</option>
                        <option value='DRA.'>DRA.</option>
                        <option value='SRITA.'>SRITA.</option>
                    </select>;
                }
            },
            {
                name: 'Nombre',
                id: 'name',
                filterable: true,
                accessor: 'name'
            },
            {
                name: 'Apellidos',
                id: 'patLastName',
                filterable: true,
                accessor: (person) => `${person.patLastName} ${person.matLastName}`
            },
            {
                name: 'Especialidad',
                id: 'specialty.name',
                filterable: true,
                accessor: (person) => person.specialty ? person.specialty.name : ''
            },
            {
                name: 'Residencia',
                id: 'residence',
                filterable: true,
                accessor: (person) => person.residence,
            },
            {
                name: 'Email',
                id: 'email',
                filterable: true,
                accessor: 'email'
            },
            {
                name: 'Tipo de miembro',
                id: 'membership.type',
                filterable: true,
                accessor: (person) => person.membership !== null && person.membership.type
            },
        ];

        if(window.security.core.canManageMembers()) {
            definition.unshift(
                {
                    name: 'Acciones', accessor: (person) =>
                        <span className='actions-cell'>
                        <button className='btn btn-xs btn-primary' onClick={(e) => {
                            e.stopPropagation();
                            return this.setState({editingPerson: person})
                        }}><i className='ti-pencil'/></button>
                            &nbsp;
                            <button className='btn btn-xs btn-danger' onClick={(e) => {
                                e.stopPropagation();
                                return this.setState({deletingPerson: person})
                            }}><i className='ti-trash'/></button>
                            &nbsp;
                    </span>
                });
        }

        return definition;
    }


    render() {
        return (
            <div className="container-fluid People">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Miembros de la asociación</h4>
                            </div>
                            <div className="card-content">

                                <div className='buttonContainer'>
                                    {window.security.core.canManageMembers() &&
                                        <button className='btn btn-success btn-fill btn-magnify pull-right'
                                                onClick={() => this.setState({addingPerson: true})}>
                                            <span className='btn-label'><i className='ti-plus'/></span>
                                        </button>
                                    }
                                    <a href={this.context.api.people.exportUrl(this.tableState ? this.tableState.filters : null, true, 'xlsx')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.people.exportUrl(this.tableState ? this.tableState.filters : null, true, 'pdf')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix'></div>
                                </div>

                                <Table
                                    pageSizes={[10, 15, 25, 50, 100, 200]}
                                    paginated
                                    defaultPageSize={200}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.peopleMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition()}
                                    data={this.props.people}
                                    trProps={(row, index) => ({onClick: () => this.setState({detailingPerson: index})})}
                                />
                            </div>

                        </div>
                    </div>

                </div>

                {this.state.addingPerson ?
                    <PersonFormModal
                        onHide={() => this.setState({addingPerson: false})}
                        onSubmit={this.addPerson}
                        disabled={this.state.addingLoading}
                    />
                    : null}

                {this.state.editingPerson ?
                    <PersonFormModal
                        onHide={() => this.setState({editingPerson: false})}
                        onSubmit={this.editPerson}
                        defaultValues={this.state.editingPerson}
                        photoUrl={this.state.editingPerson.photo ? this.context.api.appFiles.getUrl(this.state.editingPerson.photo.id) : undefined}
                        editing
                        disabled={this.state.editingLoading}
                    />
                    : null}

                {this.state.deletingPerson ?
                    <DeletePersonModal
                        person={this.state.deletingPerson}
                        onHide={() => this.setState({deletingPerson: false})}
                        onConfirm={this.deletePerson}
                    />
                    : null}

                {this.state.detailingPerson !== false ?
                    <PersonDetailModal
                        onAnyChange={() => this.loadData(this.tableState)}
                        person={this.props.people[this.state.detailingPerson]}
                        onHide={() => this.setState({detailingPerson: false})}
                        canEdit={window.security.core.canManageMembers()}
                        canDownloadCredential={true}
                    />
                    : null}

            </div>
        );
    }
}

const mapStateToProps = ({api: {people = [], peopleMeta = {}}}) => {
    return {people, peopleMeta}
};

export default connect(mapStateToProps)(People);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/People/index.jsx